import React, { useContext, Fragment } from 'react';
import { withStyles, Divider } from '@material-ui/core';
import Carousel from '../../carousel/Carousel';
import DataContext from '../../data/DataContext';
import { openLink } from '../../util/utilNative';

const styles = (theme) => ({
  root: {
    position: 'relative',
    letterSpacing: '-0.0313rem',
    margin: '0.375rem 0rem',
    zIndex: 1,
  },
  carousel: {
    width: '100%',
    height: '9rem',
  },
  item: {
    height: '2.3125rem',
    textAlign: 'center',
    color: theme.color.select.color,
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0rem',
    flex: 1,
  },
  vertical: {
    height: 'auto',
  },
  list: {
    display: 'flex',
    margin: '0rem 1.25rem 0rem 1.25rem',
  },
  listitem: {
    // width: "18rem",
    padding: '0rem 0.5rem 0rem 0rem',
  },
  card: {
    width: '16.25rem',
    height: '100%',
    flex: 'auto',
    background: '#fff',
    border: '0.0625rem solid #e1e1e1',
    borderRadius: '0.75rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  thumbnail: {
    height: '12.5rem',
    // padding: "0.9375rem 1.1875rem 0.75rem",
  },
  thumbnailImage: {
    // width: "auto",
    // height: "6.4375rem",
    width: '100%',
    borderRadius: '0.75rem 0.75rem 0rem 0rem',
    height: '12.5rem',
  },
  date: {
    fontSize: theme.font.size12,
    color: theme.color.message.grey,
    lineHeight: '1.08',
    margin: '0 1rem',
    textAlign: 'start',
  },
  external: {
    display: 'flex',
    flexDirection: 'column',
    // background: "#fafafa",
    // borderRadius: "0 0 0.75rem 0.75rem",
    // borderTop: "0.0625rem solid #e1e1e1",
    // marginTop: "0.625rem",
    padding: '1rem',
  },
  externalButton: {
    backgroundColor: theme.color.button.background_red,
    borderRadius: '0.375rem',
    height: '2.5rem',
    color: theme.color.button.text_white,
    fontWeight: 'bold',
    fontSize: theme.font.size14,
    // flex: 1,
    textAlign: 'center',
    border: 'none',
    padding: 0,
    background: 'transparent',
    // "&:active": {
    //   background: "rgba(38, 38, 38, 0.1)",
    // },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  title: {
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    color: theme.color.text_color.black,
    padding: '1.25rem 1rem 0.5rem 1rem',
    flexGrow: 1,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    // whiteSpace: "nowrap",
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    textAlign: 'start',
  },
});

const Card = React.forwardRef((props, ref) => {
  const { classes, data } = props;
  const context = useContext(DataContext);

  const handleClick = (event, url, action, event_action) => {
    event.stopPropagation();
    if (!ref.clickAllowed()) {
      return;
    }
    openLink(context, action, url, event_action);
  };

  return data.items.map((item, key) => (
    <div
      key={key}
      className={classes.listitem}
      onClick={(event) =>
        handleClick(
          event,
          context.userAgent.deviceType === 'mobile'
            ? item.link.mobile_url
            : item.link.url,
          item.link.type,
          item.link.event_action
        )
      }
      role={'button'}
      tabIndex={0}
      aria-label={`${
        item.buttons[0].parameters.action === 'external'
          ? context.string.aria.external + ','
          : ''
      } ${item.title}, ${item['start_date']}에서 ${item['end_date']}까지, 상세보기, ${
        key + 1
      }/${data.items.length}, 항목${data.items.length}개`}
    >
      <div className={classes.card}>
        <div className={classes.thumbnail}>
          <img
            className={classes.thumbnailImage}
            src={item['thumbnail_url']}
            alt={item.title}
          />
        </div>
        {item.title && <div className={classes.title}>{item.title}</div>}
        <div className={classes.date}>
          {item['start_date']} ~ {item['end_date']}
        </div>

        <div className={classes.external}>
          {item.buttons.map((button, index) => (
            <Fragment key={index}>
              <Divider
                className={classes.externalDivider}
                orientation="vertical"
                hidden={index === 0}
                component={'div'}
                disabled
              />
              <button
                type="button"
                className={classes.externalButton}
                disabled={context.conversationEnd}
                onClick={(event) =>
                  handleClick(
                    event,
                    context.userAgent.deviceType === 'mobile'
                      ? button.parameters.mobile_url
                      : button.parameters.url,
                    button.parameters.action,
                    button.event_action
                  )
                }
              >
                <div className={classes.buttonContainer}>
                  <div>{button.label}</div>
                </div>
              </button>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  ));
});

function EventCard(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  return (
    <>
      <div className={classes.root}>
        <Carousel
          className={classes.carousel}
          component={withStyles(styles)(Card)}
          data={data}
          ariaLabel={context.string.aria.event}
        />
      </div>
    </>
  );
}
export default withStyles(styles)(EventCard);
